module.exports = __webpack_public_path__ + "static/Logo-bg-clair-70cb6985f6040f6427d9bb66d425a5a3.svg";